<template>
  <div class="page-list">
    <div class="list-banner">
      <img src="https://qn.dazuhang.com/Image_1578539742824293" class="banner-img" alt="">
      <div class="search-cover">
        <product-search
          :citylist="citylist"
          :city_name="city_name"
          :kw="query.keywords"
          @transferKw="serchGoods"
          @keywordsChange="kwChange"
        />
      </div>
    </div>
    <div class="list-cate">
      <div class="container display-flex" style="align-items:flex-start;">
        <p @click="allCategory">所有分类：</p>
        <ul>
          <li :class="activeClass == 0 ? 'active':''" @click="allCategory">所有分类</li>
          <li
            :class="activeClass == v.id ? 'active':''"
            v-for="(v,i) in category_list"
            :key="i"
            @click="chooseCategory(v,i)"
          >{{v.name}}</li>
        </ul>
      </div>
    </div>
    <div class="list-filters">
      <div class="container display-flex">
        <ul>
          <li @click="zong">
            <span>综合</span>
            <img v-if="sort_type == 0" src="/static/img/xia.png" class="icon-rise-decrease">
            <img v-else-if="sort_type ==1" src="/static/img/shang.png" class="icon-rise-decrease">
            <img v-else src="/static/img/zhengchang.png" class="icon-rise-decrease">
          </li>
          <li @click="Popularity">
            <span>人气</span>
            <img v-if="sort_type == 2" src="/static/img/xia.png" class="icon-rise-decrease">
            <img v-else-if="sort_type ==3" src="/static/img/shang.png" class="icon-rise-decrease">
            <img v-else src="/static/img/zhengchang.png" class="icon-rise-decrease">
          </li>
          <li @click="Sales">
            <span>销量</span>
            <img v-if="sort_type == 4" src="/static/img/xia.png" class="icon-rise-decrease">
            <img v-else-if="sort_type ==5" src="/static/img/shang.png" class="icon-rise-decrease">
            <img v-else src="/static/img/zhengchang.png" class="icon-rise-decrease">
          </li>
          <li @click="Price">
            <span>价格</span>
            <img v-if="sort_type == 6" src="/static/img/xia.png" class="icon-rise-decrease">
            <img v-else-if="sort_type ==7" src="/static/img/shang.png" class="icon-rise-decrease">
            <img v-else src="/static/img/zhengchang.png" class="icon-rise-decrease">
          </li>
        </ul>
        <div class="start_end display-flex">价格区间：
          <el-input size="mini" clearable class="price-input" v-model="min_price"/>
          <p></p>
          <el-input size="mini" clearable class="price-input" v-model="max_price"/>
          <span class="buttons ok_btn" @click="serchPrice">确定</span>
        </div>
      </div>
    </div>
    <div class="no-data" v-if="kong">暂无数据...</div>
    <div class="list-cont" v-loading="listLoading" v-else>
      <ul v-if="sort_type === 2" class="goods_ul container">
        <li v-for="(item,index) in goods_list2" :key="index">
          <router-link :to="{path:'/GoodsDetail', query:{id:item.id}}" target="_blank">
            <cate-product :item="item" @transferData="addToCart"/>
          </router-link>
        </li>
      </ul>
      <ul v-else-if="sort_type === 3" class="goods_ul container">
        <li v-for="(item,index) in goods_list3" :key="index">
          <router-link :to="{path:'/GoodsDetail', query:{id:item.id}}" target="_blank">
            <cate-product :item="item" @transferData="addToCart"/>
          </router-link>
        </li>
      </ul>
      <ul v-else-if="sort_type === 4" class="goods_ul container">
        <li v-for="(item,index) in goods_list4" :key="index">
          <router-link :to="{path:'/GoodsDetail', query:{id:item.id}}" target="_blank">
            <cate-product :item="item" @transferData="addToCart"/>
          </router-link>
        </li>
      </ul>
      <ul v-else-if="sort_type === 5" class="goods_ul container">
        <li v-for="(item,index) in goods_list5" :key="index">
          <router-link :to="{path:'/GoodsDetail', query:{id:item.id}}" target="_blank">
            <cate-product :item="item" @transferData="addToCart"/>
          </router-link>
        </li>
      </ul>
      <ul v-else-if="sort_type === 6" class="goods_ul container">
        <li v-for="(item,index) in goods_list6" :key="index">
          <router-link :to="{path:'/GoodsDetail', query:{id:item.id}}" target="_blank">
            <cate-product :item="item" @transferData="addToCart"/>
          </router-link>
        </li>
      </ul>
      <ul v-else-if="sort_type === 7" class="goods_ul container">
        <li v-for="(item,index) in goods_list7" :key="index">
          <router-link :to="{path:'/GoodsDetail', query:{id:item.id}}" target="_blank">
            <cate-product :item="item" @transferData="addToCart"/>
          </router-link>
        </li>
      </ul>
      <ul v-else class="goods_ul container">
        <li v-for="(item,index) in goods_list" :key="index">
          <router-link :to="{path:'/GoodsDetail', query:{id:item.id}}" target="_blank">
            <cate-product :item="item" @transferData="addToCart"/>
          </router-link>
        </li>
      </ul>
      <div v-if="last_page>1" class="list-pagination">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          class="pagination-container"
          background=""
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :total="total"
          :page-size="query.limit"
          :current-page="query.page"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { cityList } from "../api/index.js";
import { categoryList, goodsList } from "../api/goods/goods";
import { addShoppingCart } from "../api/shoppingcart/shopping_cart";
export default {
  name: "GoodsList",
  metaInfo() {
    return {
      title: "大租行-影视器材租赁分类列表",
      meta: [
      {
        name: 'keywords',
        content: '影视器材租赁分类列表,单反相机租赁,摄像机租赁,镜头租赁,相机租用,摄像机租用,直播设备租赁,录音设备租赁,灯光器材租赁,航拍,摇臂,导播,单反,镜头,灯光,录音设备,摄影人员'
      },
      {
        name: 'description',
        content:'影视器材租赁分类列表,大租行是国内专业为企业和个人提供影视器材租赁的互联网平台，可供租赁的设备有:单反相机、镜头、航拍无人机、gopro摄像机、稳定器、直播设备，影视灯光、录音话筒、轨道、摇臂等专业影视设备。'
      }
    ]
    };
  },
  data() {
    return {
      kong: false,
      sort_type: 0,
      citylist: [],
      city_name: this.$cookies.get("city_name") || "北京",

      min_price: "",
      max_price: "",
      total: 0,
      last_page: 0,

      activeClass: 0,
      category_list: [],
      goods_list: [],

      query: {
        category_id: 0,
        city_id: this.$cookies.get("city_id") || 52,
        supplier_id: 0,
        price: [],
        keywords: "",
        sort: "",
        page: 1,
        limit: 15
      },
      listLoading: false
    };
  },
  components: {
    productSearch: resolve =>
      require(["../components/productSearch.vue"], resolve),
    cateProduct: resolve => require(["../components/cateProduct.vue"], resolve)
  },
  computed: {
    goods_list1() {
      return this.goods_list.sort(compare("sort")).reverse();
    },
    goods_list2() {
      return this.goods_list.sort(compare("popularity")).reverse();
    },
    goods_list3() {
      return this.goods_list.sort(compare("popularity"));
    },
    goods_list4() {
      return this.goods_list.sort(compare("sales_volume")).reverse();
    },
    goods_list5() {
      return this.goods_list.sort(compare("sales_volume"));
    },
    goods_list6() {
      return this.goods_list.sort(compare("price")).reverse();
    },
    goods_list7() {
      return this.goods_list.sort(compare("price"));
    }
  },
  methods: {
    kwChange(data) {
      this.query.keywords = data;
    },
    jumpPage(id) {
      this.$router.push({
        path: "GoodsDetail",
        query: {
          id: id
        }
      });
    },
    //快速加入购物车
    addToCart(data) {
      var goods_id = data.id,
        config_id = data.config_id;
      if (goods_id == 0 || config_id == 0) {
        this.$message.warning("参数错误，添加失败！");
        return;
      }
      var arr = {
        user_id: this.$cookies.get("uid"),
        browser_token: this.$cookies.get("browser_token"),
        goods_id: goods_id,
        num: 1,
        config_id: config_id,
        shipping_type: 1,
        start_time: "",
        end_time: ""
      };
      addShoppingCart(arr).then(response => {
        if (response.data.code != "error") {
          this.$message.success("添加成功！");
          this.$store.dispatch("userOrder/changeCartNumAction");
        }
      });
    },
    //排序
    Price() {
      this.sort_type = this.sort_type === 7 ? 6 : 7;
    },
    Sales() {
      this.sort_type = this.sort_type === 4 ? 5 : 4;
    },
    Popularity() {
      this.sort_type = this.sort_type === 2 ? 3 : 2;
    },
    zong() {
      this.sort_type = this.sort_type === 0 ? 1 : 0;
      this.goods_list.reverse();
    },
    //选择商品分类
    chooseCategory(item, i) {
      this.activeClass = item.id;
      this.query.category_id = item.id;
      this.query.page = 1; //重置页码
      this.getGoodsList();
    },
    //所有分类的商品
    allCategory() {
      this.activeClass = 0;
      this.query.category_id = 0;
      this.query.page = 1; //重置页码
      this.getGoodsList();
    },
    //搜索关键字
    serchGoods(keywords) {
      this.query.keywords = keywords;
      this.query.city_id =
        !this.$cookies.get("city_id") ||
        this.$cookies.get("city_id") == "undefined"
          ? 52
          : this.$cookies.get("city_id");
      this.query.page = 1; //重置页码
      this.getGoodsList();
    },
    //搜索价格区间
    serchPrice() {
      this.query.page = 1; //重置页码
      var price = [this.min_price, this.max_price];
      this.query.price = price;
      this.getGoodsList();
    },
    //获取商品分类
    getCategoryList() {
      categoryList(this.query).then(response => {
        if (response.data.code != "error") {
          this.category_list = response.data.data || [];
        }
      });
    },
    //更新页码
    handleCurrentChange(val) {
      this.query.page = val;
      this.getGoodsList();
    },
    //获取商品列表
    getGoodsList() {
      this.listLoading = true;
      goodsList(this.query).then(response => {
        this.listLoading = false;
        if (response.data.code != "error") {
          //防止数据不更新（偶发）
          var arr = [];
          this.goods_list = arr.concat(response.data.data.data);
          this.total = response.data.data.total;
          this.last_page = response.data.data.last_page;
          this.per_page = response.data.data.per_page;
          if (response.data.data.data.length == 0) {
            this.kong = true;
          } else {
            this.kong = false;
          }
        }
      });
    },
    //获取城市列表
    getCityData() {
      cityList().then(res => {
        if (res.data.code != "error") {
          this.citylist = res.data.data || [];
          this.$cookies.set(
            "citylist",
            JSON.stringify(res.data.data),
            60 * 60 * 24
          );
        }
      });
    },
    initData() {
      if (this.$route.query.cid) {
        this.query.category_id = this.$route.query.cid;
        this.activeClass = this.$route.query.cid;
      }
      if (this.$route.query.keywords) {
        this.query.keywords = this.$route.query.keywords;
      }
      if (this.$route.query.supplier_id) {
        this.query.supplier_id = this.$route.query.supplier_id;
      }
      //获取商品分类
      this.getCategoryList();
      //获取商品列表
      this.getGoodsList();
      //获取城市列表
      this.getCityData();
    }
  },
  created() {
    this.initData();
  }
};

function sortKey(array, key) {
  return array.sort(function(a, b) {
    var x = a[key];
    var y = b[key];
    return x < y ? -1 : x > y ? 1 : 0;
  });
}
function compare(property) {
  return function(obj1, obj2) {
    var value1 = obj1[property];
    var value2 = obj2[property];
    return value1 - value2; // 升序
  };
}
</script>
<style scoped>
.page-list {
  background: #f5f5f5;
}
.list-cont {
  margin: 20px 0;
  min-height: 200px;
}
.goods_ul {
  overflow: hidden;
}
.goods_ul li {
  float: left;
  width: 18.1%;
  list-style: none;
  margin: 10px;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
}

/* 筛选 搜索 */
.list-filters {
  padding: 15px;
  font-size: 14px;
  color: #333;
  background: #fff;
}

.list-filters ul li {
  display: flex;
  align-items: center;
  float: left;
  margin-right: 30px;
  cursor: pointer;
}
.list-filters ul li p {
  padding-top: 10px;
  margin-top: 5px;
}
.list-filters ul li p img {
  display: block;
  width: 11px;
  height: 7px;
}
.list-filters ul li p img:last-child {
  margin-top: 3px;
}
.start_end {
  margin-left: 50px;
  color: #999;
}
.start_end .price-input {
  width: 90px;
  margin-left: 10px;
  margin-right: 10px;
  border-color: #e6e6e6;
  color: #999;
}
.start_end p {
  width: 15px;
  height: 1px;
  border-bottom: 1px solid #e6e6e6;
}
.ok_btn,
.search_btn {
  width: 60px;
  height: 31px;
  cursor: pointer;
  /* background-image: -webkit-linear-gradient(right, #ffd778, #fd314a); */
  background: -webkit-linear-gradient(to right, #ffd778, #fd314a);
  /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(to right, #ffd778, #fd314a);
  /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(to right, #ffd778, #fd314a);
  /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, #ffd778, #fd314a);
}
.search_div input {
  width: 268px;
}
.search_div .search_btn {
  width: 31px;
  display: inline-block;
}
.search_btn img {
  width: 14px;
  height: 14px;
}

/* 全部分类 */
.list-cate {
  padding-top: 20px;
  font-size: 14px;
  color: #333;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
}
.list-cate p {
  min-width: 75px;
}
.list-cate ul li {
  float: left;
  margin-left: 15px;
  line-height: 20px;
  margin-bottom: 8px;
  list-style: none;
  cursor: pointer;
  padding: 0 10px;
}
.display-flex {
  display: flex;
  align-items: center;
}
.display-flex ul li:hover:not(.active) {
  color: red;
}
.list-filters ul {
  margin: 0;
  list-style: none;
}
.active {
  background: #ff6b56;
  color: #fff;
  border-radius: 3px;
}
input {
  height: 31px;
  border-radius: 4px;
  outline: none;
  border: 0;
  text-indent: 1em;
  border: 1px solid #999;
}
.buttons {
  text-align: center;
  line-height: 31px;
  border-radius: 4px;
  color: #fff;
}
.list-banner {
  position: relative;
  background-size: 100% 100%;
}
.banner-img {
  width: 100%;
}
.search-cover {
  width: 500px;
  position: absolute;
  bottom: 38px;
  z-index: 200;
  font-size: 12px;
  padding: 10px 10px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.3);
  left: 0;
  right: 0;
  margin: 0 auto;
}

.goods_ul li:hover {
  box-shadow: 4px 2px 15px #999;
}

.icon-rise-decrease {
  width: 13px;
  height: 15px;
  margin: -1px 3px 0;
}

.list-cont .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: red;
  color: #fff;
}

.list-pagination {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// src/pages/GoodsList.vue